import pluralize from "pluralize";
import React, {useRef} from "react";

import {thousandSeparatedInt} from "@/lib/format.tsx";
import {
  LimitCheckWithInstantCheckout,
  LimitCheckWithInstantCheckoutComponent,
} from "@/pages/billing/v2/InstantCheckout/LimitCheckWithInstantCheckout.tsx";

export const LimitCheckStatuspages = React.forwardRef((_, ref) => {
  const checkerRef = useRef<LimitCheckWithInstantCheckoutComponent>();
  const checkIfLimitHit = () => {
    return checkerRef.current?.checkIfLimitHit();
  };
  React.useImperativeHandle(ref, () => ({
    checkIfLimitHit,
  }));
  return (
    <LimitCheckWithInstantCheckout
      getUpgradeMessage={(hasSubscription, limitName) =>
        `${!hasSubscription ? "Subscribe" : "Upgrade"} now to allocate more ${pluralize(limitName)} to your account.`
      }
      getRequestMessage={(hasSubscription, limitName) =>
        `If you would like to ${!hasSubscription ? "request a subscription" : "upgrade your account"} to allocate additional ${pluralize(limitName)}, please send a request to the owner of this account below to upgrade.`
      }
      getReasonMessage={(hasSubscription, limitName, limitValue) =>
        !hasSubscription
          ? `You have reached the limit of ${thousandSeparatedInt(limitValue)} ${pluralize(limitName, limitValue)} available on your Free Trial`
          : `You have reached your account limit of ${thousandSeparatedInt(limitValue)} ${pluralize(limitName, limitValue)}`
      }
      getTitleMessage={(hasSubscription, limitName) =>
        `${hasSubscription ? "Upgrade" : "Subscribe"} to create new ${pluralize(limitName)}`
      }
      limitField="limit_statuspages"
      ref={checkerRef}
    />
  );
});
